import ButtonToolbar from 'components/ButtonToolbar'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import AddIcon from '@material-ui/icons/Add'
import { PatrimonyActionTypes } from 'store/patrimony/patrimonyTypes'
import FilterListIcon from '@material-ui/icons/FilterList'

import { useMediaQuery } from '@material-ui/core'

import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

import useTypedSelector from '../../hooks/useTypedSelector'
import getPatrimony, { setFilters } from 'store/patrimony/patrimonyActions'
import moment from 'moment'

export const PatrimonyToolbar = () => {
  const dispatch = useDispatch()
  const matches = useMediaQuery('(min-width: 600px)')

  const [isOpenModalFilter, setOpenModalFilter] = useState(false)

  const { filters } = useTypedSelector(({ patrimonyState }) => ({
    filters: patrimonyState.filters,
  }))

  const [state, setState] = useState({
    dateFrom: filters.dateFrom,
    dateTo: filters.dateTo,
  })

  const onChangeFilterState = (key: string) => (e: any) => {
    setState({ ...state, [key]: e.target.value })
  }

  const onClickApply = () => {
    dispatch(setFilters(state.dateTo, state.dateFrom))
    setOpenModalFilter(false)
    dispatch(getPatrimony())
  }

  return (
    <>
      <div className="flex flex-col items-center md:flex-row">
        <ButtonToolbar
          text="Novo cadastro"
          matches={matches}
          IconLeft={AddIcon}
          onClick={() => dispatch({ type: PatrimonyActionTypes.EDITING_START })}
        />

        <ButtonToolbar
          text="Filtrar"
          matches={matches}
          IconLeft={FilterListIcon}
          onClick={() => setOpenModalFilter(true)}
        />
      </div>

      <Dialog
        onClose={() => setOpenModalFilter(false)}
        open={isOpenModalFilter}
      >
        <DialogTitle>Filtro por data de aquisição</DialogTitle>
        <DialogContent>
          <div className="w-full md:w-72 flex flex-col md:flex-row space-y-6 md:space-x-4 md:space-y-0">
            <TextField
              type="date"
              label="Data inicial"
              value={
                state.dateFrom ||
                setState({
                  ...state,
                  dateFrom: moment().format('YYYY-MM-DD'),
                })
              }
              onChange={onChangeFilterState('dateFrom')}
            />

            <TextField
              type="date"
              label="Data final"
              value={
                state.dateTo ||
                setState({ ...state, dateTo: moment().format('YYYY-MM-DD') })
              }
              onChange={onChangeFilterState('dateTo')}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModalFilter(false)}>Cancelar</Button>
          <Button
            onClick={onClickApply}
            color="primary"
            disabled={!state.dateFrom || !state.dateTo}
          >
            Aplicar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
